export class FundingTexts {
  static texts() {
    return {
      modal: {
        title: ET('mps2::funding::modal::title'),
        tabs: {
          ranking: ET('mps2::funding::modal::tabs::ranking'),
          created_at: ET('mps2::funding::modal::tabs::created_at'),
        },
        item: {
          label: (nickname: string) => ET('mps2::funding::modal::item::label', { nickname }),
        },
      },
      section: {
        ranking_title: ET('mps2::funding::section::ranking_title'),
      },
    };
  }
}
